"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var ContainerContact_1 = require("../../containers/ContainerContact");
var Layout_1 = __importDefault(require("../Layout"));
var styles_1 = require("./styles");
function Contacts(_a) {
    (0, react_1.useEffect)(function () {
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }, []);
    return ((0, jsx_runtime_1.jsx)(Layout_1.default, { children: (0, jsx_runtime_1.jsx)(styles_1.Content, { children: (0, jsx_runtime_1.jsx)(ContainerContact_1.ContainerContact, {}) }) }));
}
exports.default = (0, react_1.memo)(Contacts);
